import { Button, Flex } from '@chakra-ui/react';
import { FC, Fragment, useState } from 'react';

import { ProfilePopupNew } from '@/components/ui/shared/profile/ProfilePopup/ProfilePopupNew';
import { ThinProfile } from '@/resources/ThinProfile';

interface ILectureSpeakersList {
  profiles: Array<ThinProfile>;
}

export const LectureSpeakersList: FC<ILectureSpeakersList> = ({ profiles }) => {
  const [profileSelected, setProfileSelected] = useState<ThinProfile | null>(null);

  if (profiles?.length === 0) return;

  return (
    <Fragment>
      <Flex flexWrap="wrap" mt={1} gap={1}>
        {profiles.map((profile, index) => (
          <Button
            variant="link"
            onClick={() => setProfileSelected(profile)}
            fontWeight="normal"
            colorScheme="black"
            key={profile.id}
          >
            {profile.fullName}
            {index < profiles.length - 1 && ', '}
          </Button>
        ))}
      </Flex>

      {profileSelected && (
        <ProfilePopupNew
          isOpen={Boolean(profileSelected)}
          onClose={() => setProfileSelected(null)}
          profiles={profiles}
          defaultSelectedProfile={profileSelected}
        />
      )}
    </Fragment>
  );
};
